export default {
	namespaced: true,

	state: {

		pageItems: null,
	},

	getters: {

		getPreviousPageItems: state => {
			return state.pageItems;
		},

	},

	mutations: {

		setPreviousPageItems: (state, callback) => {
			state.pageItems = callback;
		},

	},

	actions: {

		changePreviousPageItems: (context, callback) => {
			context.commit('setPreviousPageItems', callback);
		},

	},
}
